export default __webpack_public_path__ + "assets/6b6c6010e2c0ac69ad640fbff9d34a1f.svg";